// extracted by mini-css-extract-plugin
module.exports = {"model_icon":"Models_model_icon__2oQZs","model_name":"Models_model_name__3eOLT"};